var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Dashboard"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    clipPath: "url(#clip-Dashboard)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16868",
    "data-name": "Group 16868",
    transform: "translate(2.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grid",
    transform: "translate(0 1.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H4.233V4.233H0Z",
    transform: "translate(0 0.877)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H4.233V4.233H0Z",
    transform: "translate(5.776 2.993) rotate(-45)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H4.233V4.233H0Z",
    transform: "translate(6.653 7.529)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H4.233V4.233H0Z",
    transform: "translate(0 7.529)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1687",
    "data-name": "Rectangle 1687",
    width: 16,
    height: 16,
    transform: "translate(-2.118)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.9ac764e949441a311a1c6db2f13ba0ab.svg";
export { ForwardRef as ReactComponent };